export default "__VITE_ASSET__49adcd93__"